import { Routes, Route, Navigate } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Companies from './pages/Companies';
import Users from './pages/Users';
import Connections from './pages/Connections';
import AiProfilePage from './pages/AiProfilePage';
import Generate from './pages/Generate';
import Calendar from './pages/Calendar';
import PostEditor from './pages/PostEditor';
import Notifications from './pages/Notifications';

function Protected({ children }) {
  return (
    <RequireAuth>
      <AppShell>{children}</AppShell>
    </RequireAuth>
  );
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Navigate to="/login" replace />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/empresas" element={<Protected><Companies /></Protected>} />
      <Route path="/usuarios" element={<Protected><Users /></Protected>} />
      <Route path="/conexoes" element={<Protected><Connections /></Protected>} />
      <Route path="/ia" element={<Protected><AiProfilePage /></Protected>} />
      <Route path="/gerar" element={<Protected><Generate /></Protected>} />
      <Route path="/lote" element={<Navigate to="/gerar" replace />} />
      <Route path="/calendario" element={<Protected><Calendar /></Protected>} />
      <Route path="/posts/:id" element={<Protected><PostEditor /></Protected>} />
      <Route path="/notificacoes" element={<Protected><Notifications /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
